export default class ZamrzovalnikObj {
    strings_omare = [
        "180 cm - 261 l zamrzovalnika",
        "180 cm - 217 l zamrzovalnika",
        "177 cm - 274 l zamrzovalnika",
        "150 cm - 208 l zamrzovalnika",
        "85 cm - 83,5 l zamrzovalnika",
        "85 cm - 90 l zamrzovalnika",
        "61 cm - 53 l zamrzovalnika",
        "153 cm - 174 l zamrzovalnika",
        "141 cm - 168 l zamrzovalnika",
        "163 cm - 240 l zamrzovalnika",
        "173 cm - 210 l zamrzovalnika",
        "140 cm - 164 l zamrzovalnika",
        "165 cm - 193 l zamrzovalnika",
        "170 cm - 210 l zamrzovalnika",
        "155 cm - 259 l zamrzovalnika",
        "170 cm - 296 l zamrzovalnika",
        "185 cm - 277 l zamrzovalne omare",
        "82 cm - 96 l zamrzovalne omare",
        "84,5 cm - 94 l zamrzovalne omare",
    ];

    poraba_omare = [
        [153,	218,	306,	400,	546,	655,	728,	801],
        [140,	200,	280,	367,	500,	600,	667,	733],
        [157,	224,	313,	410,	560,	671,	746,	821],
        [137,	196,	275,	360,	491,	589,	654,	720],
        [101,	144,	202,	265,	361,	433,	481,	529],
        [103,	147,	206,	270,	368,	441,	490,	539],
        [92,	132,	184,	241,	329,	395,	439,	483],
        [127,	182,	255,	334,	455,	546,	607,	668],
        [126,	180,	251,	329,	449,	539,	599,	658],
        [147,	210,	293,	384,	524,	629,	699,	769],
        [138,	197,	276,	361,	493,	591,	657,	723],
        [125,	178,	249,	326,	445,	534,	593,	652],
        [133,	190,	266,	348,	475,	570,	633,	697],
        [138,	197,	276,	361,	493,	591,	657,	723],
        [153,	218,	305,	399,	544,	653,	725,	798],
        [163,	233,	326,	427,	582,	699,	777,	854],
        [163,	237,	302,	427,	582,	699,	777,	854],
        [163,	142,	326,	427,	582,	699,	777,	854],
        [163,	233,	175,	427,	582,	699,	777,	854],
    ];

    strings_skrinje = [
        "110 cm - 230 l zamrzovalnika",
        "130 cm - 290 l zamrzovalnika",
        "94 cm - 184 l zamrzovalnika",
        "112 cm - 225 l zamrzovalnika",
        "160 cm - 368 l zamrzovalnika",
        "135 cm - 287 l zamrzovalnika",
        "85 cm - 300 l zamrzovalne skrinje",
        "85 cm - 400 l zamrzovalne skrinje",
        "85 cm - 150 l zamrzovalne skrinje",
    ];

    poraba_skrinje = [
        [130,	185,	259,	339,	462,	554,	616,	678],
        [145,	207,	289,	379,	517,	620,	689,	758],
        [118,	168,	235,	308,	420,	504,	560,	616],
        [128,	183,	256,	335,	457,	549,	610,	671],
        [165,	235,	329,	431,	588,	706,	784,	863],
        [144,	206,	288,	377,	514,	617,	685,	754],

    ];

    ratings = [
        "A+++ (po 2006)",
        "A++ (po 2006)",
        "A+ (po 2006)",
        "A (po 2006)",
        "B (2002-2006)",
        "C (1999-2002)",
        "D (1994-1999)",
        "E (pred 1994)",
    ];

    static curr_use;
    static new_use
    static savings;
    static curr_price;
    static new_price;

    ukrep1;
    ukrep1_savings;
    new_type;
    new_size;
    new_rating;

    ukrep2;
    ukrep2_savings;

    ukrep3;
    ukrep3_savings;

    ukrep4;
    ukrep4_savings;

    constructor(type, size, rating) {
        this.type = type;
        this.size = size;
        this.rating = rating;
        this.st_select = 3;
        this.short = "Z";
        this.st_ukrepov = 0;
        this.name = "Zamrzovalnik"; 
        
        switch (type) {    
            case "1":
                console.log("sem v zamrzovalnik case");
                this.curr_use = this.poraba_omare[size-1][rating-1];
                this.size_string = this.strings_omare[size-1];
                break;
            case "2":
                console.log("sem v skrinja case");
                this.curr_use = this.poraba_skrinje[size-1][rating-1];
                this.size_string = this.strings_skrinje[size-1];           
                break;  
        }
        this.detail_string = this.size_string.concat(this.ratings[rating-1]);
    }
}